// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"M7-z"};